import { render, staticRenderFns } from "./CalendarDashboardUpcoming.vue?vue&type=template&id=1d0973ca"
import script from "./CalendarDashboardUpcoming.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardUpcoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports